import { useAppSelector } from '@hts/shared/libs';
import { Route, Routes } from 'react-router-dom';
import { GlobalLayout } from '../components';
import { AuthNavigator, NotAuthNavigator } from './navigators';

export const Navigation = () => {
  const { currentUser } = useAppSelector((state) => state.mainReducer);

  return (
    <Routes>
      <Route path="/" element={<GlobalLayout />}>
        {currentUser ? AuthNavigator : NotAuthNavigator}
      </Route>
    </Routes>
  );
};
